<template>
  <div>
    <div
      title="查看详情"
      @click="show"
    >
      <slot name="context"/>
    </div>
    <div
      v-show="detailVisible"
      class="detail "
    >
      <div class="detail-context ">
        <slot name="detail"/>
      </div>
      <div class="detail-footer">
        <md-button
          class="md-dense md-raised md-accent"
          style="margin:0 10px"
          @click="close"
        >关闭</md-button>
      </div>
      <span class="lt"/>
      <!-- <span class="rb"/> -->
    </div>
    <!-- <md-dialog :md-active.sync="showDialog" style="width:70%;height:91vh;max-width:460px;max-height:100%;">
      
     <slot name="detail"/>
     
    </md-dialog> -->
     <el-dialog
      :visible.sync="showDialog"
      custom-class="detailDialogClass"
      :append-to-body="true"
      style="min-width:250px;"
    >
        <slot name="detail"/>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detailVisible: false,
      showDialog:false,
      detialNo:490
    }
  },
  methods: {
    show() {
      // 这个是用来内部显示的，现在要弹窗显示
      // this.detailVisible = true 
      this.showDialog = true
    },
    close() {
      this.detailVisible = false
    }
  }
}
</script>
<style lang="scss">
.detailDialogClass{
  width: 460px!important;
  height: 90vh;
  max-height: 100%;
  margin-top: 5vh!important;
  .el-dialog__headerbtn{

  }
  .el-dialog__header{
    height:0;
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
    width: 100%;
    height: 100%;
  }
}
</style>

<style lang="scss" scoped>

.detail {
  color: aliceblue;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  border:0.5rem solid #ae7548;
}
.detail-context {
  background: rgba($color: #000000, $alpha: 0.8);
  height: 100px;
  position: absolute;
  bottom: 45px;
  top: 0;
  overflow: auto;
  width:100%;
  height: 100%;
}
.detail-footer {
  z-index: 3;
  position: absolute;
  bottom: 10px;
  right: 20px;
}
.lt {
    position: absolute;
    left: 0;
    top: 0;
    width: 11rem;
    height: 5rem;
    background: url('./cloud.png') no-repeat left top;
    background-size: contain;
    transform: rotateY(180deg) translate(30%, -50%);
}
.rb {
    position: absolute;
    right: 0;
    top: -5rem;
    width: 11rem;
    height: 5rem;
    background: url('../../assets/images/cloud.png') no-repeat left top;
    background-size: 100% 100%;
    transform: translate(30%, 50%);
}

</style>

